module.exports = __webpack_public_path__ + "img/dp-sy-bm5.e335b57a.png";